module.exports = __webpack_public_path__ + "img/border_rectangle1.6f666da0.svg";